export default __webpack_public_path__ + "static/media/cd.7c25fd9b.png";